<template>
  <div class="my-3">
    <div class="bg-secondary-1 rounded-pill w-20 intervention-plan-title">
      <h5 class="font-weight-bold p-2 cursor-pointer" @click="switchEditing">
        <i
          class="fa intervention-plan-icon color-green"
          :class="{
            'fa-chevron-circle-down': editing,
            'fa-chevron-circle-right': !editing,
          }"
        />
        Plan de intervención
      </h5>
    </div>
    <div v-show="editing" class="bg-secondary-1 rounded mt-3 pl-4 py-3">
      <validation-observer
        ref="interverntionPlanDocumentForm"
        v-slot="{}"
        tag="form"
      >
        <div class="row mt-0 mb-5">
          <div class="col-md-4 col-sm-12">
            <label class="color-gray-6 font-14">Tipo de Documento:</label>
            <validation-provider
              v-slot="{ errors }"
              name="documentType"
              rules="required"
            >
              <custom-drop-down
                id="document-type"
                v-model="documentTypeSelected"
                custom-error-msg="El tipo de documento es requerido."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="documentTypes"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-5 col-sm-12 file-custom">
            <label class="color-gray-6 font-14">Archivo:</label>
            <validation-provider
              v-slot="{ errors }"
              name="fileUpload"
              rules="required"
            >
              <custom-file-input
                id="file-upload-input"
                ref="fileUploadInput"
                accept=".pdf"
                :attachment-id="model.documentId"
                :custom-error-msg="'El documento es requerido.'"
                display-style="normal"
                :error="errors[0]"
                label-position="left"
                :name="model.documentFileName"
                :on-download="onDownloadFile"
                required
                :value="model.attachment"
                @input="onChangeFile"
              />
            </validation-provider>
          </div>
          <div class="col-md-3 col-sm-12 align-self-end">
            <div
              v-if="!model.documentId"
              class="ml-2 d-flex justify-content-end"
            >
              <action-button
                id="cancel-btn"
                class="mr-3"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="cancel"
              />
              <action-button
                id="save-btn"
                class="mr-4 px-4"
                i="fas fa-file-plus fa-lg"
                text="Añadir"
                variant="success"
                @click="onSaveDocument"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
//lib components
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
export default {
  name: 'InterventionPlan',
  mixins: [alertMixin],
  components: {
    CustomDropDown,
    ActionButton,
    CustomFileInput,
  },
  props: {
    contractInfo: {
      type: Object,
      default: () => {},
    },
    documentTypes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    editing: false,
    documentTypeSelected: null,
    model: {
      documentId: null,
      documentFileName: null,
      attachment: null,
    },
  }),
  computed: {},
  methods: {
    switchEditing() {
      this.editing = !this.editing;
      this.$emit('switch-editing', this.editing);
    },
    onDownloadFile(id) {
      this.$emit('download-document', id);
    },
    onChangeFile(file) {
      this.model.attachment = file;
    },
    cancel() {
      this.editing = false;
      this.$refs.fileUploadInput.removeFile();
      this.documentTypeSelected = null;
      this.model = {
        documentId: null,
        documentFileName: null,
        attachment: null,
      };
      this.$refs.interverntionPlanDocumentForm.reset();
    },
    async onSaveDocument() {
      const isValid = await this.$refs.interverntionPlanDocumentForm.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      const data = {
        contractDocumentTypeId: this.documentTypeSelected.id,
        file: this.model.attachment,
      };
      this.$emit('save-document', data);
      this.cancel();
    },
  },
};
</script>

<style scoped lang="scss">
.intervention-plan-icon {
  border: 5px white solid;
  border-radius: 50px;
}
</style>
